import { render } from "./ChartLoaders.vue?vue&type=template&id=54794a6a"
import script from "./ChartLoaders.vue?vue&type=script&lang=js"
export * from "./ChartLoaders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__